class ClientAdminController {

    constructor(
        $uibModal,
        ClientAdminService,
        CurrentUser
    ){
        'ngInject';

        this.$uibModal = $uibModal;
        this.ClientAdminService = ClientAdminService;
        this.CurrentUser = CurrentUser;
    }

    $onInit() {
        this.ClientAdminService.countryList = this.countryList;
        this.newClient = {
            name: '',
            groups: [],
            site_id: null
        };

        // We need to initialize these values so that they will work with filtering. We do it here rather than in the
        // Client component because Clients that aren't on the 1st page won't run their $onInit until you navigate to
        // their page.
        this.clientList.map((c) => {
            c.displayName = c.name;
            c.displaySiteID = c.padded_site_id || '';
        });

        this.itemsPerPage = 50;

        this.clientHeaders = [
            {
                text: 'Client Name',
                showSort: true,
                columnSize: 'lg',
                nestedDisplayKeys: ['name']
            },
            {
                text: 'Client ID',
                showSort: true,
                columnSize: 'md',
                nestedDisplayKeys: ['site_id']
            },
            {
                text: 'Groups',
                showSort: false,
                columnSize: 'lg'
            },
            {
                text: 'Surveys',
                showSort: true,
                columnSize: 'md',
                nestedDisplayKeys: ['next_survey_date']
            }
        ];

        this.clientListDetail = {
            sortIndex: 0,
            sortProp: this.clientHeaders[0].nestedDisplayKeys.join('.'),
            sortPropDisplay: this.clientHeaders[0].text,
            isReverseSort: false,
            headers: this.clientHeaders,
            startingIndex: 0
        };


        this.campusHeaders = [
            {
                text: 'Client Name',
                showSort: true,
                columnSize: 'md',
                nestedDisplayKeys: ['client_name']
            },
            {
                text: 'Location Name',
                showSort: true,
                columnSize: 'md',
                nestedDisplayKeys: ['name']
            },
            {
                text: 'Client ID',
                showSort: true,
                columnSize: 'md',
                nestedDisplayKeys: ['client_site_id']
            },
            {
                text: 'Location ID',
                showSort: true,
                columnSize: 'md',
                nestedDisplayKeys: ['location_site_id']
            },
            {
                text: 'Address 1',
                showSort: false,
                columnSize: 'md',
            },
            {
                text: 'Address 2 ',
                showSort: false,
                columnSize: 'md',
            },
            {
                text: 'City',
                showSort: false,
                columnSize: 'md',
            },
            {
                text: 'State/Province',
                showSort: false,
                columnSize: 'md',
            },
            {
                text: 'Zip Code',
                showSort: false,
                columnSize: 'md',
            }
        ];

        this.campusListDetail = {
            sortIndex: 0,
            sortProp: this.campusHeaders[0].nestedDisplayKeys.join('.'),
            sortPropDisplay: this.campusHeaders[0].text,
            isReverseSort: false,
            headers: this.campusHeaders,
            startingIndex: 0
        };

        this.facilityHeaders = [
            {
                text: 'Client Name',
                showSort: true,
                columnSize: 'md',
                nestedDisplayKeys: ['client_name']
            },
            {
                text: 'Location Name',
                showSort: true,
                columnSize: 'md',
                nestedDisplayKeys: ['location_name']
            },
            {
                text: 'Facility Name',
                showSort: true,
                columnSize: 'md',
                nestedDisplayKeys: ['name']
            },
            {
                text: 'Client ID',
                showSort: true,
                columnSize: 'md',
                nestedDisplayKeys: ['client_site_id']
            },
            {
                text: 'Location ID',
                showSort: true,
                columnSize: 'md',
                nestedDisplayKeys: ['location_site_id']
            },
            {
                text: 'Facility ID',
                showSort: true,
                columnSize: 'md',
                nestedDisplayKeys: ['facility_site_id']
            },
            {
                text: 'Address 1',
                showSort: false,
                columnSize: 'md',
            },
            {
                text: 'Address 2 ',
                showSort: false,
                columnSize: 'md',
            },
            {
                text: 'City',
                showSort: false,
                columnSize: 'md',
            },
            {
                text: 'State/Province',
                showSort: false,
                columnSize: 'md',
            },
            {
                text: 'Zip Code',
                showSort: false,
                columnSize: 'md',
            },
            {
                text: 'Active?',
                showSort: true,
                columnSize: 'md',
                nestedDisplayKeys: ['is_active']
            }
        ];

        this.facilityListDetail = {
            sortIndex: 0,
            sortProp: this.facilityHeaders[0].nestedDisplayKeys.join('.'),
            sortPropDisplay: this.facilityHeaders[0].text,
            isReverseSort: false,
            headers: this.facilityHeaders,
            startingIndex: 0
        };

    }

    /***
     * Open the Client Add modal.
     */
    openClientAddModal() {
        this.clearNewClient();
        this.addModal = this.$uibModal.open({
            component: 'ClientAddModal',
            size: 'md',
            windowClass: 'custom-modal client-add-modal',
            resolve: {
                groupList: () => this.groupList,
                newClient: this.newClient,
                parentController: () => this
            }
        });
    }

    clearNewClient() {
       this.newClient = {
           name: '',
           groups: [],
           site_id: null
       };
    }

    canAddNewClient() {
        return this.CurrentUser.canAddClientLocationFacility()
    }

    /***
     * Create a new client. Only adds the client to the UI if the request is successful. Otherwise,
     * displays an error message to the user.
     */
    createClient() {
        const groupIds = this.newClient.groups.map((g) => g.id);
        if (this.newClient.name.length > 0) {
            this.ClientAdminService.createClient(this.newClient.name, groupIds, this.newClient.site_id)
                .then((successResponse) => {
                       let newClient = successResponse.data;
                       newClient.groups = this.newClient.groups;
                       newClient.displayName = newClient.name;
                       newClient.displaySiteID = newClient.site_id;
                       this.clientList.push(newClient);
                       this.clearNewClient();
                       this.addModal.close()

                    }, (errorResponse) => {
                        if ('name' in errorResponse['data']) {
                            alert(errorResponse['data']['name'])
                        }
                        else {
                            alert(`There was an error adding the client "${this.newClient.name}"`);
                        }
                    });
        }
    }

    /***
     * Deletes the given client. Only removes it from the UI if the request is successful.
     * Otherwise, displays an error message to the user.
     *
     * @param client    the client being deleted.
     */
    deleteClient(client) {
        const newStatus = client.is_active === 1 ? 0 : 1;
        const newStatusVerb = newStatus === 1 ? 'reactivating' : 'deleting';
        this.ClientAdminService.deleteClient(client, newStatus)
            .then((successResponse) => {
                   client.is_active = newStatus;
                }, (errorResponse) => {
                    alert(`There was an error ${newStatusVerb} client "${client.name}"`);
                });
    }

    /***
     * Reset the column filters and display all results.
     */
    resetFilters() {
        this.search = {
            displayName: undefined,
            displaySiteID: undefined
        }
    }

    resetCampusFilters() {
        this.campusSearch = {};
    }

    resetFacilityFilters() {
        this.facilitySearch = {};
    }

    /***
     * Sort the list of clients based on "name" column.
     * Iterates through 3 sort states, tracked by this.sortIndex:
     * 0 - no sort
     * 1 - sort ascending
     * 2 - sort descending
     *
     * @param sortColumnName    the column to sort the table by.
     * @param listDetail    the dictionary that contains the sort details being adjusted
     */
    sortList(sortColumnName, listDetail) {

        const sortColumn = listDetail.headers.filter((column) => column.text === sortColumnName)[0];
        if (sortColumn === undefined || !sortColumn.showSort) {
            return;
        }
        if (listDetail.sortPropDisplay !== sortColumnName) {
            listDetail.sortIndex = 0;
        }
        listDetail.sortPropDisplay = sortColumnName;
        listDetail.sortIndex = (listDetail.sortIndex + 1) % 3;
        listDetail.isReverseSort = listDetail.sortIndex === 2;
        listDetail.sortProp = listDetail.sortIndex === 0 ? null : sortColumn.nestedDisplayKeys.join('.');
    }

    /***
     * Update the given client. Only updates the UI if the request is successful. Otherwise,
     * displays an error message to the user.
     *
     * @param client        the client being updated.
     * @param updatedName       the new name for this client.
     * @param updatedSiteID     the new site ID for this client.
     */
    updateClient(client, updatedName, updatedSiteID) {
        const groupIds = client.groups.map((g) => g.id);
        return this.ClientAdminService.updateClient(client.id, updatedName, groupIds, updatedSiteID)
            .then(
                (successResponse) => {
                    client.name = updatedName;
                    client.displayName = updatedName;
                    client.site_id = updatedSiteID;
                    client.displaySiteID = updatedSiteID;
                    return successResponse;
                },
                (errorResponse) => {
                    if ('name' in errorResponse['name']) {
                        alert(errorResponse['data']['name'])
                    }
                    else {
                        alert(`There was an error updating client "${client.name}"`);
                    }
                    return errorResponse;
                });
    }

    /***
     * A callback for the paginator component. Updates the ng-repeat list with the correct starting index, based on
     * the current page.
     *
     * @param startingIndex     the index within the array of items to start displaying in the list.
     */
    updatePaginationStartingIndex(startingIndex, listDetail) {
        listDetail.startingIndex = startingIndex;
    }

}

export default ClientAdminController;


// WEBPACK FOOTER //
// ./app/components/client-admin/client-admin-controller.js